import { makeAutoObservable } from 'mobx'
import type { IResponseFullAICallingAgent } from 'entities/AICalling/api/types'

export class EscalateToHumanStore {
  isEscalate = false

  constructor(
    readonly parent: {
      response?: IResponseFullAICallingAgent | null
    }
  ) {
    this.isEscalate = parent.response?.human_transfer_enabled || false
    makeAutoObservable(this)
  }

  get params() {
    return {
      human_transfer_enabled: this.isEscalate,
    }
  }

  setIsEscalate = (value: boolean) => {
    this.isEscalate = value
  }
}
